module.exports = __webpack_public_path__ + "img/sensitivity-icon-3.bb89aa02.svg";